import * as React from 'react';

import {
  accountViewIcon,
  clipboardCheckIcon,
  demoViewIcon,
  giftIcon,
  googleClassroomIcon,
  groupAccountIcon,
  searchMapIcon,
  tableCheckIcon,
  globeIcon,
  aiIcon,
  bookIcon,
} from '../../../Shared/index';
import { requestGet, } from '../../../../modules/request'
import DemoGuardedButton from '../shared/demoGuardedButton'

interface HandyActionProps {
  disabledForDemoAccount?: boolean;
  icon: {
    alt: string;
    src: string;
  };
  text: string;
  link: string;
  showNewTag?: boolean;
};

function HandyAction({ disabledForDemoAccount, icon, text, link, showNewTag }: HandyActionProps): JSX.Element {
  function handleClick(): void {
    window.location.href = link;
  }

  const buttonContent = (
    <React.Fragment>
      <div className="left-side-container">
        <img alt={icon.alt} src={icon.src} />
        <p>{text}</p>
      </div>
      {showNewTag && <span className="gold-new-tag">NEW</span>}
    </React.Fragment>
  );

  if (disabledForDemoAccount) {
    return (
      <DemoGuardedButton className="handy-action handy-action-button focus-on-light" onClick={handleClick}>
        {buttonContent}
      </DemoGuardedButton>
    );
  }

  return (
    <a className="handy-action focus-on-light" href={link}>
      {buttonContent}
    </a>
  );
}

const ExploreDemoAction = ({setShowDemoModal}) => {
  function handleClick() {
    setShowDemoModal(true);
  }

  return (
    <DemoGuardedButton className="handy-action handy-action-button focus-on-light" onClick={handleClick}>
      <img alt={demoViewIcon.alt} src={demoViewIcon.src} />
      <span>Explore a demo teacher account</span>
    </DemoGuardedButton>
  );
}

const ReferTeacherAction = () => {
  const handleClick = () => {
    window.location.href = '/referrals'
  }

  return (
    <DemoGuardedButton className="handy-action handy-action-button focus-on-light" onClick={handleClick}>
      <img alt={giftIcon.alt} src={giftIcon.src} />
      <span>Refer a teacher</span>
    </DemoGuardedButton>
  )
}

const HandyActions = ({ linkedToClever, setShowDemoModal}) => {
  const [hasAssignedSocialStudiesActivities, setHasAssignedSocialStudiesActivities] = React.useState(false)
  const [hasAssignedWorldHistory1200ToPresentActivities, setHasAssignedWorldHistory1200ToPresentActivities] = React.useState(false)
  const [hasAssignedWorldHistory1750ToPresentActivities, setHasAssignedWorldHistory1750ToPresentActivities] = React.useState(false)
  const [hasAssignedScienceActivities, setHasAssignedScienceActivities] = React.useState(false)
  const [hasAssignedFishtankActivities, setHasAssignedFishtankActivities] = React.useState(false)

  React.useEffect(() => {
    requestGet('/teachers/progress_reports/assigned_content_hub_activities_status',
      ({ has_assigned_science_activities, has_assigned_social_studies_activities, has_assigned_world_history_1200_to_present_activities, has_assigned_world_history_1750_to_present_activities, has_assigned_fishtank_activities, }) => {
        setHasAssignedScienceActivities(has_assigned_science_activities)
        setHasAssignedSocialStudiesActivities(has_assigned_social_studies_activities)
        setHasAssignedWorldHistory1200ToPresentActivities(has_assigned_world_history_1200_to_present_activities)
        setHasAssignedWorldHistory1750ToPresentActivities(has_assigned_world_history_1750_to_present_activities)
        setHasAssignedFishtankActivities(has_assigned_fishtank_activities)
      }
    )
  })

  function socialStudiesHandyAction() {
    if (!hasAssignedSocialStudiesActivities) {
      return null
    }

    let href = '/teachers/progress_reports/social-studies'

    if (hasAssignedWorldHistory1200ToPresentActivities && !hasAssignedWorldHistory1750ToPresentActivities) {
      href = '/teachers/progress_reports/social-studies/world-history-1200-to-present'
    }

    if (!hasAssignedWorldHistory1200ToPresentActivities && hasAssignedWorldHistory1750ToPresentActivities) {
      href = '/teachers/progress_reports/social-studies/world-history-1750-to-present'
    }

    return <HandyAction icon={globeIcon} link={href} showNewTag={true} text="Social Studies Dashboard" />
  }

  return(
    <section aria-labelledby="handyActionsTitle" className="handy-actions">
      <h2 id="handyActionsTitle">Handy Actions</h2>
      {hasAssignedFishtankActivities && <HandyAction icon={bookIcon} link="/assign/literature" showNewTag={true} text="Literature Dashboard" />}
      {socialStudiesHandyAction()}
      {hasAssignedScienceActivities && <HandyAction icon={aiIcon} link="/teachers/progress_reports/interdisciplinary-science/building-ai-knowledge" showNewTag={true} text="Interdisciplinary Science Dashboard" /> }
      <HandyAction icon={searchMapIcon} link="/assign/activity-library" text="Explore activity library" />
      <HandyAction icon={clipboardCheckIcon} link="/assign/diagnostic" text="Assign a diagnostic" />
      <HandyAction icon={tableCheckIcon} link="/teachers/classrooms/scorebook" text="View activity summary report" />
      <HandyAction icon={accountViewIcon} link="/teachers/classrooms?modal=view-as-student" text="View as a student" />
      <ExploreDemoAction setShowDemoModal={setShowDemoModal} />
      <ReferTeacherAction />
      <HandyAction icon={groupAccountIcon} link="/teachers/classrooms/new" text="Add a class" />
      {
        !linkedToClever &&
        <HandyAction
          disabledForDemoAccount={true}
          icon={googleClassroomIcon}
          link="/teachers/classrooms?modal=google-classroom"
          text="Import classes from Google"
        />
      }
    </section>
  )
}

export default HandyActions
